export default __webpack_public_path__ + "static/media/stackshare.35fd9a87.svg";